<template>
  <div v-if="!userLoggedIn">
    <v-layout align-center justify-center class="pt-10 pb-10">
      <v-flex xs12 sm8 md4>
        <v-form ref="pwdForm">
        <v-card class="elevation-12">
          <v-toolbar dark color="#425058">
            <v-toolbar-title>Login to SELANGOR</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-text-field
              v-model="pwd"
              id="password"
              prepend-icon="mdi-lock"
              name="password"
              label="Password"
              type="password"
              :error-messages="errMsg"
              :rules="[(v) => !!v || 'Password required']"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#425058" class="white--text" @click="LogIn(pwd)">Login</v-btn>
          </v-card-actions>
        </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "SignInWindow",
  data() {
    return {
      pwd: "",
      errMsg:''
    };
  },
  methods: {
    ...mapActions(["logIn"]),
    async LogIn(pwd){
      if(this.$refs.pwdForm.validate()){
        this.errMsg = await this.logIn(pwd)?'':"Wrong password"
      }

    }
  },
  computed: {
    ...mapGetters(["getIsUserLoggedIn"]),
    userLoggedIn() {
      return this.getIsUserLoggedIn;
    },
  },
  watch: {
    userLoggedIn(newVal) {
      if (newVal) {
        this.$router.push({ name: "home" });
      }
    },
  },
};
</script>
<style>
div {
  --footer-color: red;
}
</style>
